function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_22",
  transform: "translate(-478.731 -4536.939)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_16"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M512.7,4599.9c-1.8,0-3.6-0.2-5.5-0.5c-15.7-3-26-18.2-23-33.9l0,0c3-15.7,18.2-26,33.9-23 c7.6,1.5,14.2,5.8,18.5,12.2c4.3,6.4,5.9,14.1,4.5,21.7C538.5,4590.2,526.3,4599.9,512.7,4599.9z M485.2,4565.6l1,0.2 c-2.8,14.6,6.8,28.8,21.4,31.6c7.1,1.4,14.3-0.1,20.2-4.2s10-10.2,11.4-17.2c1.4-7.1-0.1-14.3-4.2-20.2s-10.2-10-17.2-11.4 c-14.6-2.8-28.8,6.8-31.6,21.4L485.2,4565.6z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Groupe_21",
  transform: "translate(506.385 4557.223)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_119",
  className: "st1",
  d: "M2.2,0C1.6,0,1,0.3,0.6,0.8C0.1,1.5-0.1,2.3,0,3.2v8.1c-0.1,0.7,0.2,1.5,0.6,2.1 c0.4,0.5,1,0.7,1.6,0.7c0.6,0,1.2-0.3,1.6-0.7c0.5-0.6,0.7-1.3,0.7-2.1V2.9c0.1-0.8-0.2-1.5-0.6-2.2C3.5,0.2,2.9,0,2.2,0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_120",
  className: "st1",
  d: "M15.4,22.5c-0.1-0.3-0.4-0.7-0.7-1.3l-4.1-6.6c-0.3-0.5-0.2-1.2,0.2-1.5l1.7-1.5 c1.2-1.1,1.8-2,1.8-2.7c0-0.5-0.2-1-0.6-1.4c-0.4-0.4-0.9-0.6-1.4-0.6c-0.4,0-0.9,0.1-1.2,0.4c-0.5,0.4-1,0.9-1.4,1.4l-3,3.2l0,0 C5,13.6,6,14.9,6,14.9l2,3.6l3,5.1c0.4,0.6,0.8,1.1,1.2,1.7c0.3,0.3,0.8,0.5,1.3,0.5c0.6,0,1.2-0.2,1.6-0.6 c0.4-0.5,0.6-1.1,0.6-1.7C15.6,23.1,15.5,22.8,15.4,22.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_121",
  className: "st1",
  d: "M0.1,23.5c0,1.2,1,2.1,2.2,2.1c1.2,0,2.1-1,2.1-2.2c0-1.2-1-2.1-2.2-2.1 C1.1,21.3,0.1,22.3,0.1,23.5z"
})));

function SvgKimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67.9 67.9",
    style: {
      enableBackground: "new 0 0 67.9 67.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKimple);
export default __webpack_public_path__ + "static/media/kimple.ef4256fd.svg";
export { ForwardRef as ReactComponent };